module.exports = __webpack_public_path__ + "media/images/close-ce68e40cda886ba8684ed80818489745.svg";